import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "src/config/colors";
import ModalLayout from "src/components/common/Layout/ModalLayout";

interface DetailModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const DetailModal: React.FC<DetailModalProps> = ({ isOpen, onClose }) => {
  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      paperSx={{
        height: "55%",
        width: { xs: "90%", md: "40%" },
        borderRadius: "5px",
      }}
    >
      <Box
        sx={{
          padding: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          marginY: "auto",
        }}
      >
        <Typography
          component="h4"
          sx={{
            mb: 4,
            fontSize: "25px",
            fontWeight: "700",
            color: colors.blue,
          }}
        >
          Чтобы купить дешевле:
        </Typography>
        <Typography>
          <Box
            component="span"
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              color: colors.darkBlue,
            }}
          >
            1.{" "}
          </Box>
          Сделайте заказ на ЦВА <br />
          <br />
          <Box
            component="span"
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              color: colors.darkBlue,
            }}
          >
            2.{" "}
          </Box>
          Придите за ним в аптеку Апрель <br />
          <br />{" "}
          <Box
            component="span"
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              color: colors.darkBlue,
            }}
          >
            3.{" "}
          </Box>
          Бесплатно получите карту лояльности и оформите платную подписку
          «Аптечный клуб» на 1, 3, 6, 12 месяцев, от 168₽
          <br />
          <br />{" "}
          <Box
            component="span"
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              color: colors.darkBlue,
            }}
          >
            4.{" "}
          </Box>
          Купите заказ со скидкой! Она будет действовать и на следующие заказы в
          течение оплаченного периода
        </Typography>
      </Box>
    </ModalLayout>
  );
};

export default DetailModal;
